module.exports = __webpack_public_path__ + "img/reu.17909e37.svg";